import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { cn } from "../lib/utils";

const API = '/api';

/**
 * Unified user avatar component.
 * Uses uploaded avatar > Google picture > favicon fallback.
 */
export function UserAvatar({ user, className, size = "md" }) {
  const sizes = { xs: "w-6 h-6", sm: "w-8 h-8", md: "w-9 h-9", lg: "w-12 h-12", xl: "w-16 h-16" };
  const textSizes = { xs: "text-[10px]", sm: "text-xs", md: "text-sm", lg: "text-base", xl: "text-lg" };
  const sizeClass = sizes[size] || sizes.md;
  const textClass = textSizes[size] || textSizes.md;

  // Priority: uploaded avatar > Google picture > favicon
  let src = null;
  if (user?.avatar_storage_path) {
    src = `${API}/files/${user.avatar_storage_path}`;
  } else if (user?.picture) {
    src = user.picture;
  }

  const fallbackChar = (user?.name || user?.username || "U").charAt(0).toUpperCase();

  return (
    <Avatar className={cn(sizeClass, className)} data-testid="user-avatar">
      {src ? (
        <AvatarImage src={src} alt={user?.name || user?.username || ""} />
      ) : null}
      <AvatarFallback className={cn(textClass, "bg-primary/10 text-primary")}>
        {fallbackChar}
      </AvatarFallback>
    </Avatar>
  );
}
